export const listenStreakReminderMessages = {
  title: 'Keep Your Streak Going!',
  body: (streak: number) =>
    `Your ${streak} day listening streak will end in 6 hours! Keep listening to earn daily rewards!`
}
